import { AppAlert, AppDataTable, AppSearchBox } from '@9b3kuq5phwuk4txw/kiban-react-ui'
import { useMemo, useState } from 'react'
import { useSalesforceProjectMembers } from '@/shared-hooks/useSalesforceProjectMembers'
import { filterMembers } from '../../-lib/member-filter'
import { createMemberColumns } from './components/columns'

interface MembersTabProps {
  opportunityId: number
  salesforceProjectId: number | null
}

export function MembersTab({ salesforceProjectId }: MembersTabProps) {
  const [searchText, setSearchText] = useState('')
  const [showAlert, setShowAlert] = useState(true)

  // メンバー一覧取得
  const { data, isLoading, error } = useSalesforceProjectMembers(salesforceProjectId)

  // カラム定義
  const columns = useMemo(() => createMemberColumns(), [])

  // 検索フィルタリング
  const filteredMembers = useMemo(() => filterMembers(data?.members ?? [], searchText), [data?.members, searchText])

  if (!salesforceProjectId) {
    return (
      <div className='h-full flex flex-col p-4'>
        <AppAlert type='info'>このオポチュニティにはSalesforceプロジェクトが紐づいていません</AppAlert>
      </div>
    )
  }

  const members = data?.members ?? []

  const is404 = !!error && (error.message.includes('not found') || error.message.includes('404'))
  const memberErrorMessage = error
    ? is404
      ? 'Salesforceプロジェクトが見つかりません'
      : `メンバーの取得に失敗しました: ${error.message}`
    : undefined
  const memberErrorType = is404 ? 'info' : 'error'

  return (
    <div className='grid h-full grid-rows-[auto_minmax(0,1fr)]'>
      {/* ヘッダー部分 */}
      <div className='px-4'>
        {/* 情報アラート */}
        {showAlert && (
          <AppAlert type='info' className='mb-4' closable onClose={() => setShowAlert(false)}>
            PKSで設定されている情報を参照しています（毎朝5時に同期）
          </AppAlert>
        )}

        <div className='mb-4'>
          <AppSearchBox
            label='関係者を検索'
            value={searchText}
            onChange={setSearchText}
            placeholder='社員番号、メンバー名、役職名で絞り込み'
          />
        </div>
      </div>

      {/* メンバー一覧テーブル */}
      <AppDataTable
        data={filteredMembers}
        columns={columns}
        isLoading={isLoading}
        errorMessage={memberErrorMessage}
        errorType={memberErrorType}
        pageSize={20}
        defaultSortKey='id'
        defaultSortDirection='desc'
        getRowKey={(row) => row.id}
        emptyMessage={
          members.length === 0 ? 'メンバーはまだ登録されていません' : '検索条件に一致するメンバーが見つかりませんでした'
        }
        containerClassName='pb-4'
      />
    </div>
  )
}
